module.exports = __webpack_public_path__ + "static/comingsoon2-1b90cf5eff8668b53a046a63ff09f8cb.png";